import {
  PropsWithChildren,
  ReactElement,
  useRef,
  useLayoutEffect,
} from 'react';
import { get, has } from 'lodash';

import classNames from 'classnames';
import { useTheme } from 'styled-components';
import { useContextSelector } from 'use-context-selector';
import { IonHeader, IonToolbar } from '@ionic/react';

import { PageContext } from '../../contexts/PageContext';

import { HeaderBack } from './HeaderBack/HeaderBack';
import { HeaderLogo } from './HeaderTitle/HeaderLogo';
import { HeaderActions } from './HeaderActions/HeaderActions';
import { HeaderClose } from './HeaderClose/HeaderClose';
import { GRADIENT } from './Header.const';

export type HeaderProps = PropsWithChildren<{
  className?: string;
}>;

interface HeaderComponent {
  (props: HeaderProps): ReactElement;
  Back: typeof HeaderBack;
  Logo: typeof HeaderLogo;
  Actions: typeof HeaderActions;
  Close: typeof HeaderClose;
}

export const Header: HeaderComponent = ({ children, className }) => {
  const { palette } = useTheme();
  const toolbar = useRef<HTMLIonToolbarElement>();

  const headerBackground = useContextSelector(
    PageContext,
    ({ headerBackground }) => headerBackground
  );

  const background = (() => {
    if (has(GRADIENT, headerBackground)) {
      return get(GRADIENT, headerBackground);
    }
    return get(palette, headerBackground);
  })();

  useLayoutEffect(() => {
    const style = document.createElement('style');
    style.innerHTML = `
    .toolbar-container {
      margin: 0 auto;
      max-width: var(--max-content-width);
    }
    .toolbar-background {
      height: 101%;
    }`;
    toolbar.current.shadowRoot.appendChild(style);
  }, []);

  return (
    <IonHeader
      collapse="fade"
      className={classNames(className, 'ion-no-border')}
    >
      <IonToolbar ref={toolbar} style={{ '--background': background }}>
        {children}
      </IonToolbar>
    </IonHeader>
  );
};

Header.Back = HeaderBack;
Header.Logo = HeaderLogo;
Header.Actions = HeaderActions;
Header.Close = HeaderClose;
